var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.vehicle_stock_info &&
    _vm.vehicle_stock_info.sold &&
    _vm.vehicle_stock_info.sold.json &&
    _vm.vehicle_stock_info.sold.json.unshipped &&
    _vm.$userIsSuperAdmin()
    ? _c("div", { attrs: { title: "Inspection" } }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "table",
              { staticClass: "table table-bordered inspection-table-nichibo" },
              [
                _c("tr", [
                  _c("td", { staticClass: "label" }, [_vm._v("Stock#")]),
                  _c("td", [
                    _vm._v(_vm._s(_vm.showInspectionValue("stock_no")))
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", { staticClass: "label" }, [_vm._v("Reference#")]),
                  _c("td", [
                    _vm._v(_vm._s(_vm.showInspectionValue("reference_no")))
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", { staticClass: "label" }, [_vm._v("Vessel")]),
                  _c("td", [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.showInspectionValue("vessel"))
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", { staticClass: "label" }, [_vm._v("KM")]),
                  _c("td", [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.showInspectionValue("km"))
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", { staticClass: "label" }, [_vm._v("Grade")]),
                  _c("td", [_vm._v(_vm._s(_vm.showInspectionValue("grade")))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", { staticClass: "label" }, [_vm._v("Color")]),
                  _c("td", [_vm._v(_vm._s(_vm.showInspectionValue("colour")))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", { staticClass: "label" }, [_vm._v("Engine")]),
                  _c("td", [_vm._v(_vm._s(_vm.showInspectionValue("engine")))])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", { staticClass: "label" }, [_vm._v("Chassis")]),
                  _c("td", [_vm._v(_vm._s(_vm.showInspectionValue("chassis")))])
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("tr", [
                  _c("td", { staticClass: "label" }, [_vm._v("Equipment")]),
                  _c("td", [_vm._v(_vm._s(_vm.showInspectionValue("km")))])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "table",
              { staticClass: "table table-bordered inspection-table-nichibo" },
              [
                _c("tr", [
                  _c("td", { staticClass: "label" }, [_vm._v("Price")]),
                  _c("td", [
                    _vm._v(
                      "¥" +
                        _vm._s(
                          _vm.numberWithCommas(
                            _vm.showInspectionValue("fob_jpy")
                          )
                        )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", { staticClass: "label" }, [_vm._v("Shipped From")]),
                  _c("td", [
                    _vm._v(_vm._s(_vm.showInspectionValue("shipped_from")))
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", { staticClass: "label" }, [_vm._v("Destination")]),
                  _c("td", [
                    _vm._v(_vm._s(_vm.showInspectionValue("destination")))
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", { staticClass: "label" }, [_vm._v("Vessel")]),
                  _c("td", [
                    _c("h3", {
                      domProps: {
                        innerHTML: _vm._s(_vm.showInspectionValue("vessel"))
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", { staticClass: "label" }, [
                    _vm._v("Scheduled Departure")
                  ]),
                  _c("td", [
                    _vm._v(
                      _vm._s(_vm.showInspectionValue("scheduled_departure"))
                    )
                  ])
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "table",
          { staticClass: "table table-bordered inspection-table-nichibo" },
          [
            _vm._m(1),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "label" }, [_vm._v("Notes")]),
              _c("td", [_vm._v(_vm._s(_vm.comments.comments))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "label" }, [_vm._v("Options")]),
              _c("td", [_vm._v(_vm._s(_vm.comments.options))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "label" }, [_vm._v("Condition")]),
              _c("td", [_vm._v(_vm._s(_vm.comments.condition))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "label" }, [_vm._v("Accessories")]),
              _c("td", [_vm._v(_vm._s(_vm.showInspectionValue("accessories")))])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "table",
          {
            staticClass:
              "table table-bordered inspection-table-nichibo width-25"
          },
          [
            _vm._m(2),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "label" }, [_vm._v("Fuel")]),
              _c("td", [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.showInspectionValue("fuel"))
                  }
                })
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "label" }, [_vm._v("Stability Control")]),
              _c("td", [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.showInspectionValue("stability_control", true)
                    )
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "label" }, [_vm._v("Cambelt or Chain")]),
              _c("td", [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.showInspectionValue("belt_or_chain"))
                  }
                })
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "label" }, [_vm._v("Trim Colour")]),
              _c("td", [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.showInspectionValue("trim_colour"))
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "label" }, [_vm._v("Stereo")]),
              _c("td", [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.showInspectionValue("stereo"))
                  }
                })
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "label" }, [_vm._v("Drive Type")]),
              _c("td", [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.showInspectionValue("drive"))
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "label" }, [_vm._v("Transmission")]),
              _c("td", [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.showInspectionValue("shift"))
                  }
                })
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "label" }, [_vm._v("RIMS")]),
              _c("td", [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.showInspectionValue("rims"))
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "label" }, [_vm._v("Trim Material")]),
              _c("td", [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.showInspectionValue("trim_material"))
                  }
                })
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "label" }, [_vm._v("Trim Colour")]),
              _c("td", [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.showInspectionValue("trim_colour"))
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "label" }, [_vm._v("No. Airbags")]),
              _c("td", [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.showInspectionValue("air_bag_number"))
                  }
                })
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "label" }, [_vm._v("Cruise Control")]),
              _c("td", [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.showInspectionValue("cruise_control", true)
                    )
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "label" }, [
                _vm._v("\n                Camera\n            ")
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _vm.valueTruthy("camera_none") === true
                    ? [_vm._v("None")]
                    : [
                        _vm.valueTruthy("camera_rear") === true
                          ? [_vm._v("Rear")]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.valueTruthy("camera_front") === true
                          ? [_vm._v("Front")]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.valueTruthy("camera_side") === true
                          ? [_vm._v("Side")]
                          : _vm._e()
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _c("td", { staticClass: "label" }, [
                _vm._v("Factory Suspension")
              ]),
              _c("td", [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.showInspectionValue("factory_suspension", true)
                    )
                  }
                })
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "table",
          {
            staticClass:
              "table table-bordered inspection-table-nichibo width-25"
          },
          [
            _vm._m(3),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "label" }, [
                _vm._v("Total Panels Damaged")
              ]),
              _c("td", [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.showInspectionValue("total_damage_panels")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "label" }, [_vm._v("Tyre Treat Front")]),
              _c("td", [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.showInspectionValue("tyre_tread_front")
                    )
                  }
                }),
                _vm._v("mm")
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "label" }, [
                _vm._v("Total on Bumper Corners Damaged")
              ]),
              _c("td", [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.showInspectionValue("total_damage_bumper_corners")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "label" }, [_vm._v("Tyre Treat Rear")]),
              _c("td", [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.showInspectionValue("tyre_tread_rear")
                    )
                  }
                }),
                _vm._v("mm")
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "label" }, [_vm._v("Underbody")]),
              _c("td", [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.showInspectionValue("underbody"))
                  }
                })
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(" ")]),
              _c("td", [_vm._v(" ")])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "table",
          {
            staticClass:
              "table table-bordered inspection-table-nichibo width-25"
          },
          [
            _vm._m(4),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "label" }, [_vm._v("Cigarette Burn")]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _vm.valueTruthy("no_cigarette_burn") === true
                    ? [_vm._v("None")]
                    : [
                        _vm.valueTruthy("cigarette_burn_hole") === true
                          ? [_vm._v("Hole")]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.valueTruthy("cigarette_surface_burn") === true
                          ? [_vm._v("Surface")]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.valueTruthy("cigarette_burn_seat") === true
                          ? [_vm._v("Seat")]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.valueTruthy("cigarette_burn_door_trim") === true
                          ? [_vm._v("Trim")]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.valueTruthy("cigarette_burn_roof_lining") === true
                          ? [_vm._v("Roof-Lining")]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.valueTruthy("cigarette_burn_floor_mat") === true
                          ? [_vm._v("Mat")]
                          : _vm._e()
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _c("td", { staticClass: "label" }, [_vm._v("Smell")]),
              _c("td", [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.showInspectionValue("smell"))
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "label" }, [_vm._v("Dirt")]),
              _c("td", [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.showInspectionValue("dirt"))
                  }
                })
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "label" }, [_vm._v("Dash Board Damage")]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _vm.valueTruthy("dash_board_no_damage") === true
                    ? [_vm._v("No Damage")]
                    : [
                        _vm.valueTruthy("dash_board_crack") === true
                          ? [_vm._v("Dashboard-Crack")]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.valueTruthy("dash_board_glue_navi_stuck") === true
                          ? [_vm._v("Glue-Navi-Stuck")]
                          : _vm._e()
                      ]
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "label" }, [
                _vm._v("Dash Board Scratch")
              ]),
              _c("td", [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.showInspectionValue("smell"))
                  }
                })
              ]),
              _vm._v(" "),
              _c("td"),
              _c("td")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "table",
          {
            staticClass:
              "table table-bordered inspection-table-nichibo width-25"
          },
          [
            _vm._m(5),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "label" }, [_vm._v("Side Mirror")]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _vm.showInspectionValue("side_mirror_no_damage") === true
                    ? [_vm._v("No Damage")]
                    : [
                        _vm.valueTruthy("side_mirror_crack") === true
                          ? [
                              _vm._v(
                                "\n                        Crack " +
                                  _vm._s(
                                    _vm.showInspectionValue(
                                      "side_mirror_crack_type"
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ]
                          : _vm._e()
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _c("td", { staticClass: "label" }, [_vm._v("Power Window")]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _vm.showInspectionValue("power_window_working") ===
                  "Power Window Works"
                    ? [_vm._v("Power Window Works")]
                    : [
                        _vm.valueTruthy(
                          "power_window_right_front_not_working"
                        ) === true
                          ? [_vm._v("Right-front-not-working")]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.valueTruthy(
                          "power_window_left_front_not_working"
                        ) === true
                          ? [_vm._v("Left-front-not-working")]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.valueTruthy(
                          "power_window_right_rear_not_working"
                        ) === true
                          ? [_vm._v("Right-rear-not-working")]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.valueTruthy(
                          "power_window_left_rear_not_working"
                        ) === true
                          ? [_vm._v("Left-rear-not-working")]
                          : _vm._e()
                      ]
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("Front Window Screen")]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _vm.valueTruthy("front_window_screen_no_damage") === true
                    ? [_vm._v("No Damage")]
                    : [
                        _vm.valueTruthy("front_window_screen_stone_chip") ===
                        true
                          ? [_vm._v("Stone-chip")]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.valueTruthy("front_window_screen_crack") === true
                          ? [_vm._v("Crack")]
                          : _vm._e()
                      ]
                ],
                2
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "table",
          {
            staticClass:
              "table table-bordered inspection-table-nichibo width-25"
          },
          [
            _vm._m(6),
            _vm._v(" "),
            _c("tr", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.showInspectionRows([
                    "tv",
                    "rear_percel_blind",
                    "head_rest",
                    "head_rest_seat_missing",
                    "suspension_adjustable",
                    "suspension_aftermarket_spring",
                    "suspension_aftermarket_shock",
                    "power_slide_door",
                    "van_doors",
                    "van_floor",
                    "scratches_panels",
                    "scratches_bumper_corners",
                    "scratch_and_dent_comment",
                    "dents_panels",
                    "dents_bumper_corners",
                    "snow_tyres",
                    "cracked_tyres",
                    "smoking_or_not",
                    "interior_comment"
                  ])
                )
              }
            })
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "label" }, [_vm._v("Transmission")]),
      _c("td")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", { attrs: { colspan: "4" } }, [_vm._v("Comments")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", { attrs: { colspan: "4" } }, [_vm._v("Options")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", { attrs: { colspan: "4" } }, [_vm._v("Exterior Condition")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", { attrs: { colspan: "4" } }, [_vm._v("Interior")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", { attrs: { colspan: "4" } }, [
        _vm._v("Instruments and Controls")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [_c("th", { attrs: { colspan: "4" } }, [_vm._v("Other")])])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-805e87a0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-805e87a0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleStock/NichiboInspection.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-805e87a0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleStock/NichiboInspection.vue
// module chunks = 0